import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import BlogImage from '../../../images/Ellipse 1.png';
import './BlogCard.css';

const BlogCard = ({blogItem}) => {
    return (
        <div className='col-md-4 position-relative BlogCard'>
            <div className='shadow rounded p-4'>
                <div className='d-flex p-4 align-items-center'>
                    <img src={BlogImage} alt="" style={{height:'60px'}} />
                    <div className='ms-2'>
                        <h6 className='fw-bold'>{blogItem.name}</h6>
                        <p className='text-muted m-0'>23 April 2019</p>
                    </div>
                </div>
                <h5 className='fw-bold'>{blogItem.title}</h5>
                <p className='text-muted fs-5'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda ipsa voluptate voluptas at nostrum delectus.</p>
            </div>
                            
            <div className='BlogCardOverlay position-absolute top-0 bottom-0 rounded p-4 text-white'>
                <h5 className='mt-5' >{blogItem.name}</h5>
                <p className='m-0'>23 April 2019</p>
                <h5 className='fw-bold mt-5'>{blogItem.title}</h5>
                <div className='display-4 mt-4'><BsArrowRight/></div>
            </div>
        </div>
    );
};

export default BlogCard;